import React from 'react';

import { SharedFileSystemProps } from '../../types/SharedFileSystemProps';
import { Filename } from '../Filename/Filename';
import { Folder } from '../Folder/Folder';

export const FileSystem = ({ file, folder }: SharedFileSystemProps) => {
  if (file) {
    return <Filename {...file} />;
  }
  if (folder) {
    return <Folder {...folder} />;
  }
  return null;
};
